import { notification } from '@antoree/ant-ui';
import { AxiosError, AxiosResponse } from 'axios';

import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
  useQuery,
  UseQueryOptions,
} from 'react-query';
import httpClient from 'utils/httpClient';
import { AvailableTime } from 'configs/types';

export const AVAILABLE_TIME = '/v2/teacher-available-time';

export type RetrieveAvailableResponse = {
  availableTimes: AvailableTime[];
};

export type RetrieveAvailableQuery = {
  teacherId: number;
  startedAt: string;
  endedAt: string;
  pageIndex?: number;
};

export const retrieveAvailableTime = ({
  teacherId,
  startedAt,
  endedAt,
}: RetrieveAvailableQuery) => {
  const parsedQuery = {
    'teacher-id': teacherId,
    'day-of-year-from': startedAt,
    'day-of-year-to': endedAt,
  };

  return httpClient.get<RetrieveAvailableResponse>(AVAILABLE_TIME, {
    params: parsedQuery,
  });
};

export const useRetrieveAvailableTime = (
  query: RetrieveAvailableQuery,
  opts?: UseQueryOptions<
    AxiosResponse<RetrieveAvailableResponse>,
    AxiosError<any>
  >,
) => {
  return useQuery<AxiosResponse<RetrieveAvailableResponse>, AxiosError<any>>(
    [AVAILABLE_TIME, query],
    () => retrieveAvailableTime({ ...query }),
    {
      ...opts,
    },
  );
};
